export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}
export const mayTryStudentLogin = (error: unknown) =>
  error instanceof ApiError && [400, 401, 403].includes(error.status);
export async function requestJSON<T>(
  url: string,
  token: string,
  options: RequestInit = {},
): Promise<T> {
  const headers = new Headers(options.headers);
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (options.body && !(options.body instanceof FormData))
    headers.set("Content-Type", "application/json");
  const response = await fetch(url, { ...options, headers });
  const payload = await response.json().catch(() => null);
  if (!response.ok)
    throw new ApiError(
      payload?.message ||
        (response.status === 403
          ? "没有访问此内容的权限"
          : response.status >= 500
            ? "服务暂时不可用，请重试"
            : "请求失败"),
      response.status,
    );
  if (payload === null && response.status !== 204)
    throw new ApiError("服务器返回了无法读取的数据", response.status);
  return payload as T;
}
